module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzNFNzJGNyIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNy44ODkgNS45NjRsLTcuNTg3LjIyM0w4LjA0LjQ1eiIvPjxwYXRoIGQ9Ik0zLjcxNCA0LjVIMjJWNkguNTcxem0xMC4zOTcgNS41MzZsNy41ODctLjIyMy03LjczOCA1LjczOHoiLz48cGF0aCBkPSJNMTguMjg2IDExLjVIMFYxMGgyMS40Mjl6Ii8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/engine-exchange.svg
// module id = 867
// module chunks = 0